import type { ServerData } from '@/types';

// A collection earns indexing when it is live, public, currently has an upcoming
// event, and has depth: either several upcoming events, or a real history of
// past ones. Creators routinely use a collection to track a recurring series, so
// a single upcoming event plus a long past record is legitimate — not the stub
// shell the bare ">= 2 upcoming" bar was aimed at. The `>= 1 upcoming` floor is
// the legacy zero-event rule (EB-263287): a collection whose events have all
// ended is not indexed, however deep its past.
const MIN_UPCOMING = 1;
const DEPTH_UPCOMING = 2;
const MIN_PAST = 10;

export function collectionIsIndexable(serverData: ServerData): boolean {
    if (!('collection' in serverData)) {
        return false;
    }
    const { collection, events_in_collection } = serverData;
    const upcoming = events_in_collection?.upcoming?.pagination?.object_count ?? 0;
    const past = events_in_collection?.past?.pagination?.object_count ?? 0;
    return (
        collection.status === 'live' &&
        !collection.is_private &&
        upcoming >= MIN_UPCOMING &&
        (upcoming >= DEPTH_UPCOMING || past >= MIN_PAST)
    );
}
